import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	linkText: {
		id: 'app.ui.scenesLink',
		defaultMessage: 'Scenes',
		description: 'The title of the scenes selection page',
	},
});
